import { SYLLABUS_ALL_ACTIONS_TYPE } from "../actions-type";

const initialState = {
  syllabusData: [],
  loading: false,
};

export const syllabusPaginationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SYLLABUS_ALL_ACTIONS_TYPE.GET_ALL_SYLLABUS:
      return {
        ...state,
        syllabusData: action.payload,
      };
    case SYLLABUS_ALL_ACTIONS_TYPE.GET_ACTIVE_SYLLABUS:
      return {
        ...state,
        syllabusData: action.payload,
        loading: false,
      };
    case SYLLABUS_ALL_ACTIONS_TYPE.SYLLABUS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SYLLABUS_ALL_ACTIONS_TYPE.GET_SYLLABUS_PAGINATION:
      return {
        ...state,
        syllabusData: action.payload,
      };
    case SYLLABUS_ALL_ACTIONS_TYPE.CREATE_SYLLABUS:
      console.log(action.payload);
      return {
        ...state,
        syllabusData: [action.payload, ...state.syllabusData],
      };
    case SYLLABUS_ALL_ACTIONS_TYPE.RESET_SYLLABUS_PAGINATION:
      return {
        ...state,
        syllabusData: [],
      };
    case SYLLABUS_ALL_ACTIONS_TYPE.UPDATE_SYLLABUS:
      return {
        ...state,
        syllabusData: state.syllabusData.map((syllabus) =>
          syllabus._id === action.payload._id ? action.payload : syllabus
        ),
      };
    case SYLLABUS_ALL_ACTIONS_TYPE.DELETE_SYLLABUS:
      return {
        ...state,
        syllabusData: state.syllabusData.filter(
          (syllabus) => syllabus._id !== action.payload
        ),
      };
    default:
      return state;
  }
};
